import type { VoucherPerformanceOrder } from '@/marketing/models/voucher';

export type VoucherOrderDisplayStatus = 'paid' | 'confirmed' | 'pending' | 'refunded';

export interface VoucherOrderStatusInput {
  status: VoucherPerformanceOrder['status'];
  settled: boolean;
}

/**
 * A settled order has already been carried by an admin payout row, so it reads as Paid whatever the
 * attribution status says. A refund still wins over settlement: the money came back.
 */
export function resolveVoucherOrderDisplayStatus({
  status,
  settled,
}: VoucherOrderStatusInput): VoucherOrderDisplayStatus {
  if (status === 'refunded') {
    return 'refunded';
  }
  return settled ? 'paid' : status;
}

export const VOUCHER_ORDER_STATUS_LABELS: Record<VoucherOrderDisplayStatus, string> = {
  paid: 'Paid',
  confirmed: 'Confirmed',
  pending: 'Pending',
  refunded: 'Refunded',
};
